const getters = {
  sidebar: state => state.app.sidebar,
  token: (state) => state.user.token,
  name: (state) => state.user.userInfo.username,
  user_id: (state) => state.user.userInfo.id
}
export default getters
